
import { Options, Vue } from 'vue-class-component'
import TopHeader from './TopHeader/TopHeader.vue'
import Search from './Search/Search.vue'

@Options({
  components: { TopHeader, Search }
})
export default class Home extends Vue {}
